import { Injectable } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { GetTransportByIdAction, GetTransportByIdFailAction, GetTransportByIdSuccessAction, LoadTransportListAction, LoadTransportListFailAction, LoadTransportListSuccessAction } from "./transport.actions";
import { PagedListingResponseOfTransportModel, TransportClient, TransportModel } from "@core/services/api.service";
import { catchError, tap } from "rxjs/operators";

export class TransportStateModel {
    public isLoading: boolean;
    public transport: TransportModel;
    public transportList: TransportModel[];
    public transportListing: PagedListingResponseOfTransportModel;
}

@State<TransportStateModel>({
    name: 'Transport',
    defaults: {
        isLoading: true,
        transport:null,
        transportList: [],
        transportListing:null

    }
})
@Injectable()
export class TransportState {
    constructor(private myTransportServive: TransportClient) { }
    @Selector()
    static getTransport(state: TransportStateModel) {
        return state.transport;
    }
    @Selector()
    static getTransportList(state: TransportStateModel) {
        return state.transportList;
    }

    @Selector()
    static getTransportListing(state: TransportStateModel) {
        return state.transportListing;
    }

    @Action(LoadTransportListAction)
    loadTransportListAction({ dispatch, patchState }: StateContext<TransportStateModel>, action: LoadTransportListAction) {
        patchState({ isLoading: true });
        localStorage.setItem('GetTransport', JSON.stringify(action.payload.GetTransportQuery));

        return this.myTransportServive.getTransportList(action.payload.GetTransportQuery).pipe(
            tap((transportList) => dispatch(new LoadTransportListSuccessAction({ transportList }))),
            catchError((err) => dispatch(new LoadTransportListFailAction()))
        );
    }
    @Action(LoadTransportListSuccessAction)
    loadTransportListSuccessAction(ctx: StateContext<TransportStateModel>, action: LoadTransportListSuccessAction) {
        ctx.patchState({
            isLoading: false,
            transportList: action.payload.transportList.results,
            transportListing: action.payload.transportList
        });
    }

    @Action(LoadTransportListFailAction)
    loadTransportListFailAction(ctx: StateContext<TransportStateModel>, action: LoadTransportListFailAction) {
        ctx.patchState({
            isLoading: false,
            transportList: [],
            transportListing: null
        });
    }
    @Action(GetTransportByIdAction)
    getTransportByIdAction({ patchState, dispatch }: StateContext<TransportStateModel>, action: GetTransportByIdAction) {
        patchState({ isLoading: true });
        return this.myTransportServive.getTransportById(action.transportId).pipe(
            tap((transport) => dispatch(new GetTransportByIdSuccessAction(transport))),
            catchError(error => {
                dispatch(new GetTransportByIdFailAction());
                throw error;
            })
        );
    }
    @Action(GetTransportByIdSuccessAction)
    getTransportByIdSuccessAction({ patchState }: StateContext<TransportStateModel>, action: GetTransportByIdSuccessAction) {
        patchState({ transport: action.payload });
    }
    @Action(GetTransportByIdFailAction)
    getTransportByIdFailAction(ctx: StateContext<TransportStateModel>, action: GetTransportByIdFailAction) {
        ctx.patchState({
            isLoading: false,
            transport: null
        });
    }

}
